module.exports = __webpack_public_path__ + "coins_1.d2d7bc43ee3f0139366e73b069556448.svg";